import React from "react";

export default function RemoveIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#EB5757" />
      <path d="M6 13V11H18V13H6Z" fill="white" />
    </svg>
  );
}
